import {createAction} from 'web-app/util/redux/famly-app-helpers';
import type {ReportType} from 'web-app/react/modals-container/manage-report-modal/types';

const domain = 'ENTITIES/ACCIDENT_INCIDENT_REPORTS';

export const {
    action: loadReport,
    success: loadReportSuccess,
    failed: loadReportFailed,
} = createAction(`${domain}/LOAD_REPORT`, (report: ReportType) => ({report}));

export const {
    action: fetchAllForChild,
    success: fetchAllForChildSuccess,
    failed: fetchAllForChildFailed,
} = createAction(`${domain}/FETCH_ALL_FOR_CHILD`, (childId: string) => ({childId}));

export const {
    action: deleteReport,
    success: deleteReportSuccess,
    failed: deleteReportFailed,
    aborted: deleteReportAborted,
} = createAction(`${domain}/DELETE_REPORT`, (reportId: string, childId: string) => ({reportId, childId}));

export const {
    action: acknowledge,
    success: acknowledgeSuccess,
    failed: acknowledgeFailed,
} = createAction(
    `${domain}/ACKNOWLEDGE`,
    (reportId: string) => ({reportId}),
    data => data,
    (error, reportId) => ({error, reportId}),
);
